import React, { useEffect } from "react";
import "./AccountTile.css";
import Post from "../../../../Apis/backlink/Post";
import { getAPIUrlBM } from "../../../../utils/config";
import { useNavigate } from "react-router-dom";
import { RotatingLines as Loader } from "react-loader-spinner";
import { toast } from "react-toastify";

// interface AccountTileProps {
//   id: string;
//   name: string;
//   profile_pic: string;
//   searchconsoleemail: string;
//   sites: Object[];
//   uuid: string;
//   getAuthenticationUrlForIndexMeNow: () => {};
// }

const URLCleaning = (url) => {
  let domain;
  if (url?.indexOf("://") > -1) {
    domain = url?.split("/")[2];
  } else {
    domain = url?.split("/")[0];
  }
  if (domain?.indexOf("www.") > -1) {
    domain = domain?.split("www.")[1];
  }
  domain = domain?.split(":")[0];
  domain = domain?.split("?")[0];
  return domain;
};

const UpdatePlanPopup = ({ onClose }) => {
  const navigate = useNavigate();
  return (
    <div
      className="popup-box"
      onClick={(event) => {
        const inside = document.getElementById("inside_div");
        if (inside !== event.target && !inside.contains(event.target)) {
          onClose();
        }
      }}
    >
      <div
        className="boxx"
        style={{
          maxWidth: "30rem",
          height: "max-content",
        }}
        id="inside_div"
      >
        <div
          className="container d-flex flex-row justify-content-between pr-3 position-sticky fixed-top"
          style={{ backgroundColor: "#363740", fontSize: "x-large" }}
        >
          <div className="text-light my-3">Index Your Site Now </div>
          <span
            className="text-muted px-2 "
            style={{ fontSize: "xxx-large", cursor: "pointer" }}
            onClick={() => onClose()}
          >
            x
          </span>
        </div>

        <div className="boxx-down">
          <div className="meta-container-list">
            <div className="meta-container-list-limit">
              <svg
                width="70"
                height="70"
                viewBox="0 0 93 93"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M46.5 0C37.3032 0 28.3129 2.72718 20.666 7.83666C13.0191 12.9461 7.0591 20.2085 3.53962 28.7052C0.0201478 37.202 -0.900707 46.5516 0.893505 55.5717C2.68772 64.5918 7.11641 72.8773 13.6196 79.3805C20.1227 85.8836 28.4082 90.3123 37.4283 92.1065C46.4484 93.9007 55.798 92.9799 64.2948 89.4604C72.7916 85.9409 80.0539 79.9809 85.1634 72.334C90.2728 64.6871 93 55.6968 93 46.5C92.986 34.1717 88.0824 22.3524 79.365 13.635C70.6476 4.91763 58.8283 0.0140276 46.5 0ZM46.5 89.353C38.0245 89.353 29.7393 86.8397 22.6922 82.131C15.645 77.4222 10.1525 70.7295 6.90901 62.8991C3.66557 55.0688 2.81694 46.4525 4.47043 38.1398C6.12392 29.8271 10.2053 22.1915 16.1984 16.1984C22.1915 10.2053 29.8271 6.1239 38.1398 4.47041C46.4525 2.81692 55.0688 3.66555 62.8992 6.90899C70.7295 10.1524 77.4222 15.645 82.131 22.6921C86.8397 29.7393 89.353 38.0245 89.353 46.5C89.3406 57.8615 84.8217 68.7541 76.7879 76.7879C68.7541 84.8217 57.8615 89.3406 46.5 89.353ZM46.5 7.294C38.7458 7.294 31.1657 9.59339 24.7183 13.9014C18.2709 18.2094 13.2458 24.3326 10.2784 31.4965C7.31099 38.6605 6.53458 46.5435 8.04735 54.1487C9.56013 61.7539 13.2941 68.7398 18.7772 74.2228C24.2603 79.7059 31.2461 83.4399 38.8513 84.9527C46.4565 86.4654 54.3395 85.689 61.5035 82.7216C68.6675 79.7542 74.7906 74.7291 79.0986 68.2817C83.4066 61.8343 85.706 54.2542 85.706 46.5C85.6941 36.1056 81.5597 26.1403 74.2097 18.7903C66.8597 11.4404 56.8944 7.30591 46.5 7.294ZM46.5 82.059C39.4671 82.059 32.5921 79.9735 26.7445 76.0662C20.8969 72.159 16.3392 66.6054 13.6478 60.1078C10.9564 53.6103 10.2522 46.4606 11.6243 39.5628C12.9963 32.665 16.383 26.329 21.356 21.356C26.329 16.383 32.665 12.9963 39.5628 11.6243C46.4606 10.2522 53.6103 10.9564 60.1079 13.6478C66.6054 16.3391 72.159 20.8968 76.0663 26.7445C79.9735 32.5921 82.059 39.4671 82.059 46.5C82.0482 55.9275 78.2983 64.9658 71.632 71.632C64.9658 78.2983 55.9275 82.0481 46.5 82.059ZM50.753 16.947H42.247C41.6125 16.948 40.985 17.0798 40.4036 17.3341C39.8222 17.5884 39.2995 17.9598 38.868 18.425C38.4695 18.8466 38.1636 19.3468 37.9699 19.8936C37.7761 20.4403 37.6989 21.0216 37.743 21.6L40.735 59.719C40.7914 60.8818 41.2876 61.9797 42.1231 62.7903C42.9587 63.601 44.0711 64.0638 45.235 64.085H47.759C48.923 64.0638 50.0354 63.601 50.8709 62.7903C51.7064 61.9797 52.2026 60.8818 52.259 59.719L55.257 21.6C55.301 21.0218 55.2236 20.4407 55.0299 19.8941C54.8361 19.3476 54.5303 18.8475 54.132 18.426C53.7006 17.9606 53.1779 17.589 52.5966 17.3346C52.0152 17.0801 51.3876 16.9482 50.753 16.947ZM48.629 59.433C48.6356 59.6779 48.5503 59.9164 48.3898 60.1015C48.2294 60.2866 48.0054 60.4048 47.762 60.433H45.238C44.9947 60.4048 44.7707 60.2866 44.6102 60.1015C44.4497 59.9164 44.3644 59.6779 44.371 59.433L41.379 21.313C41.3761 21.2364 41.3895 21.1601 41.4183 21.0891C41.4471 21.0181 41.4906 20.954 41.546 20.901C41.6363 20.8056 41.7447 20.7293 41.8649 20.6766C41.9852 20.6239 42.1147 20.5958 42.246 20.594H50.752C50.8833 20.5958 51.0129 20.6239 51.1331 20.6766C51.2533 20.7293 51.3618 20.8056 51.452 20.901C51.5074 20.954 51.5509 21.0181 51.5797 21.0891C51.6085 21.1601 51.6219 21.2364 51.619 21.313L48.629 59.433ZM48.99 65.312H44.01C43.1428 65.3131 42.3114 65.658 41.6982 66.2712C41.085 66.8844 40.7401 67.7158 40.739 68.583V72.783C40.7401 73.6502 41.085 74.4816 41.6982 75.0948C42.3114 75.708 43.1428 76.0529 44.01 76.054H48.99C49.8572 76.0529 50.6886 75.708 51.3018 75.0948C51.915 74.4816 52.26 73.6502 52.261 72.783V68.583C52.26 67.7158 51.915 66.8844 51.3018 66.2712C50.6886 65.658 49.8572 65.3131 48.99 65.312ZM48.614 72.406H44.386V68.959H48.614V72.406Z"
                  fill="black"
                />
              </svg>
            </div>

            <div className="meta-content-container">
              Oops! You have exhausted your domain limits. <br />
              Please buy more domains to put them for indexing.
            </div>

            <button
              type="button"
              className="rounded-lg btn btn-primary text-light "
              onClick={() => {
                // window.open("https://www.seobox.ai/#comp-lj8s2fxj", "_blank");
                navigate("/indexme/pricing");
              }}
              style={{
                backgroundColor: "#4b2ca9",
                fontWeight: "500",
                height: "max-content",
                minHeight: "2.5rem",
                width: "50%",
                fontSize: "medium",
                marginTop: "1rem",
                marginLeft: "25%",
                marginRight: "25%",
              }}
            >
              Upgrade Now
            </button>

            <div className="meta-content-container-footer">
              If you have any doubts/queries about the services, please reachout
              to{" "}
              <a href="mailto:ana@backlinkchecker.info">
                ana@backlinkchecker.info
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const VerifyPopup = ({ onClose, email, url, onClick }) => {
  const navigate = useNavigate();
  return (
    <div
      className="popup-box"
      onClick={(event) => {
        const inside = document.getElementById("inside_div");
        if (inside !== event.target && !inside.contains(event.target)) {
          onClose();
        }
      }}
    >
      <div
        className="boxx"
        style={{
          maxWidth: "40rem",
          maxHeight: "80vh",
          // height: "max-content",
        }}
        id="inside_div"
      >
        <div
          className="container d-flex flex-row justify-content-between pr-3 position-sticky fixed-top"
          style={{
            backgroundColor: "#363740",
            fontSize: "x-large",
          }}
        >
          <div className="text-light my-3">Google Search Console </div>
          <span
            className="text-muted px-2 "
            style={{ fontSize: "xxx-large", cursor: "pointer" }}
            onClick={() => onClose()}
          >
            x
          </span>
        </div>

        <div
          className="boxx-down"
          style={{
            overflow: "scroll",
          }}
        >
          <div className="meta-container-list">
            <div className="meta-content-container mb-2 mt-2">
              Service Account allows us to access your resources when you are
              not online on our product.
            </div>

            <div className="worker-popup-field-list">
              <span className="Number">1</span>
              <span className="container-Icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="30"
                  width="26.25"
                  viewBox="0 0 488 512"
                >
                  <path d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z" />
                </svg>
              </span>
              <span className="container-Text">
                <span className="container-main-text">
                  <a
                    style={{
                      textDecoration: "none",
                    }}
                    href="https://search.google.com/u/1/search-console/settings"
                  >
                    Open your Google Search Console
                  </a>
                </span>
                <span className="container-main-secondary">
                  Switch to this account - {email}
                </span>
              </span>
            </div>

            <div className="worker-popup-field-list">
              <span className="Number">2</span>
              <span className="container-Icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="30"
                  width="26"
                  viewBox="0 0 512 512"
                >
                  {" "}
                  <path d="M0 256C0 209.4 12.5 165.6 34.3 127.1L144.1 318.3C166 357.5 207.9 384 256 384C270.3 384 283.1 381.7 296.8 377.4L220.5 509.6C95.9 492.3 0 385.3 0 256zM365.1 321.6C377.4 302.4 384 279.1 384 256C384 217.8 367.2 183.5 340.7 160H493.4C505.4 189.6 512 222.1 512 256C512 397.4 397.4 511.1 256 512L365.1 321.6zM477.8 128H256C193.1 128 142.3 172.1 130.5 230.7L54.2 98.5C101 38.5 174 0 256 0C350.8 0 433.5 51.5 477.8 128V128zM168 256C168 207.4 207.4 168 256 168C304.6 168 344 207.4 344 256C344 304.6 304.6 344 256 344C207.4 344 168 304.6 168 256z" />
                </svg>
              </span>
              <span className="container-Text">
                <span className="container-main-text">
                  From dropdown on top-left, select your property
                </span>
                <span className="container-main-secondary">{url}</span>
              </span>
            </div>

            <div className="worker-popup-field-list">
              <span className="Number">3</span>
              <span className="container-Icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="30"
                  width="26"
                  viewBox="0 0 512 512"
                >
                  <path d="M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z" />
                </svg>
              </span>
              <span className="container-Text">
                <span className="container-main-text">Go to: </span>
                <span className="container-main-secondary">
                  Click on Settings {">"} Users & Permissions {">"} Add User
                </span>
              </span>
            </div>

            <div className="worker-popup-field-list">
              <span className="Number">4</span>
              <span className="container-Icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="30"
                  width="26"
                  viewBox="0 0 640 512"
                >
                  <path d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM504 312V248H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V136c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z" />
                </svg>
              </span>
              <span className="container-Text">
                <span className="container-main-text">
                  Give Owner access to:{" "}
                  <span
                    className="container-main-secondary"
                    // style={{ display: "block" }}
                  >
                    {
                      process.env
                        .REACT_APP_SERVICE_ACCOUNT_EMAIL_FOR_INDEX_ME_NOW
                    }
                  </span>
                </span>
              </span>
            </div>

            <span className="noteforverifypopup">
              Note - We only use this access to send 'Request Indexing' calls
              from your search console. Nothing else ! This works only with
              'Owner' permission status. There is no other request sent from
              your search console.
            </span>

            <button
              type="button"
              className="rounded-lg btn btn-primary text-light "
              onClick={() => {
                // window.open("https://www.seobox.ai/#comp-lj8s2fxj", "_blank");
                // navigate("/backlink/pricing");
                onClick();
              }}
              style={{
                backgroundColor: "#4b2ca9",
                fontWeight: "500",
                height: "max-content",
                minHeight: "2.5rem",
                width: "50%",
                fontSize: "medium",
                marginTop: "1rem",
                marginLeft: "25%",
                marginRight: "25%",
              }}
            >
              Verify Now
            </button>

            <div className="meta-content-container-footer">
              If you have any doubts/queries about the services, please reachout
              to{" "}
              <a href="mailto:ana@backlinkchecker.info">
                ana@backlinkchecker.info
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const DomainLinks = ({ item, setUsedDomains, callingFrom }) => {
  const [sitename, setSitename] = React.useState("");
  const [sitemapcount, setSitemapcount] = React.useState(0);
  const [active, setActive] = React.useState(false);
  const [id, setId] = React.useState("");
  const [app_error, setApp_error] = React.useState("");
  const [urls, setUrls] = React.useState(0);
  const [showPopup, setShowPopup] = React.useState(false);
  const [verificationPopup, setVerificationPopup] = React.useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    setSitename(item.sitename);
    setSitemapcount(item.sitemapcount);
    setActive(item.active);
    setId(item.id);
    setApp_error(item.app_error);
    setUrls(item.urls);
  }, [item]);

  const activeMontoring = async (id) => {
    const response = await Post(getAPIUrlBM() + "/active-domain", {
      domainId: id,
      active: !active,
    });
    const { backLinkLimits } = response;
    setUsedDomains(backLinkLimits["POST/active-domain"] || 0);
    if (response.status === 200) {
      setActive(!active);
    }

    if (response.showPopup) {
      setShowPopup(true);
    }
    console.log(response);
  };

  const verifyUrl = async (url) => {
    const response = await Post(getAPIUrlBM() + "/verify-domain", {
      url: url,
    });

    toast.info(response.message);

    if (response.status === 200) {
      setVerificationPopup(false);
      return true;
    }
    return false;
  };

  return (
    <div
      key={item.accountId + item.sitename}
      className="account_console_data_grid"
    >
      {showPopup ? (
        <UpdatePlanPopup onClose={() => setShowPopup(false)}></UpdatePlanPopup>
      ) : verificationPopup ? (
        <VerifyPopup
          onClick={() => {
            // activeMontoring(item.id, item.active);
            verifyUrl(item.site_in_console).then((res) => {
              if (res) activeMontoring(item.id, item.active);
            });
          }}
          email={item.searchconsoleemail}
          url={item.sitename}
          onClose={() => setVerificationPopup(false)}
        />
      ) : null}
      <div className="site_name grid_item">
        <img
          src={`https://www.google.com/s2/favicons?domain=${URLCleaning(
            sitename,
          )}`}
          alt=""
          width={16}
          height={16}
        />
        <span>{item.sitename}</span>
      </div>
      <div className="site_map grid_item">
        <img src="/robots.svg" />
        <span>{sitemapcount} sitemaps</span>
      </div>
      <div
        className="site_urls grid_item"
        onClick={() => {
          navigate(`/${callingFrom}/links-activity`, {
            state: {
              accountId: item.accountId,
              siteId: item.id,
              siteName: item.sitename,
            },
          });
        }}
      >
        <img src="/browser.svg" />
        <span>
          {!item?.showUrlLoader || +urls ? (
            urls
          ) : (
            <Loader color="#29CC97" width={20} />
          )}{" "}
          URLs
        </span>
      </div>
      <div className="site_active grid_item">
        <span>{active ? "Active" : "Inactive"}</span>
      </div>
      <div
        className="site_button grid_item"
        style={{
          background: active ? "#828282" : "#29CC97",
          borderColor: active ? "#828282" : "#29CC97",
        }}
      >
        <button
          onClick={() => {
            if (active) activeMontoring(item.id);
            else setVerificationPopup(true);
          }}
        >
          {active ? "STOP MONITORING" : "START MONITORING"}
        </button>
      </div>

      <div
        className="view-activity-logs grid_item"
        onClick={() => {
          console.log(item);
          navigate(`/${callingFrom}/activity-logs`, {
            state: {
              accountId: item.accountId,
              siteId: item.id,
            },
          });
        }}
      >
        <span> View Activity Logs</span>
      </div>
    </div>
  );
};

const AccountTile = (props) => {
  // console.log(props);

  return (
    <div className="account_container">
      <div className="account_tile">
        <div className="account_tile_header">
          <img
            src={props.profile_pic ? props.profile_pic : "/user.svg"}
            alt={props.name}
            width={24}
            height={24}
          />

          <div className="account_tile_header_mid">
            <span>{props.searchconsoleemail}</span>
            <span className="account_property">
              {props.sites?.length} properties
            </span>
          </div>
        </div>
        <div
          className="account_button_container"
          onClick={() => props.getAuthenticationUrlForIndexMeNow()}
        >
          Reconnect Account
        </div>
      </div>
      <div className="account_console_data">
        {props?.sites?.map((item) => {
          return (
            <DomainLinks
              callingFrom={props.product}
              key={item.accountId + item.sitename}
              item={item}
              setUsedDomains={props.setUsedDomains}
            />
          );
        })}
      </div>
    </div>
  );
};

export default AccountTile;
